import React from 'react';
const STATS = [{
  value: '+1.200',
  label: 'Odontólogos'
}, {
  value: '6',
  label: 'Tomos estratégicos'
}, {
  value: '+300',
  label: 'Recursos clínicos'
}, {
  value: '99%',
  label: 'Listos para aplicar'
}];
export function Stats() {
  return <section aria-label="Resultados del Sistema OFM" className="w-full border-y border-ofm-100 bg-white px-5 py-9 sm:px-6 sm:py-12" data-id="element-246" data-mp="2ixp8giaoukw3">
      <div className="mx-auto w-full max-w-4xl" data-id="element-247" data-mp="297w0dr9r8nwl">
        <p className="text-center text-[13px] font-semibold text-ofm-800/70 sm:text-base" data-id="element-248" data-mp="2961ea9mqypqx">
          Más de 1.200 odontólogos ya dejaron de improvisar en sus tratamientos.
        </p>
        <dl className="mt-7 grid grid-cols-2 gap-y-8 sm:grid-cols-4" data-id="element-249" data-mp="2090uyhejbhuc">
          {STATS.map(stat => <div key={stat.label} className="px-2 text-center" data-id="element-250" data-mp="256sm397cuzxh">
              <dt className="sr-only" data-id="element-251" data-mp="1q909opx3urni">{stat.label}</dt>
              <dd className="font-display text-3xl font-extrabold text-ofm-900 sm:text-4xl" data-id="element-252" data-mp="1qbmewiwiwv2k">
                {stat.value}
              </dd>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-ofm-800/60 sm:text-xs" data-id="element-253" data-mp="54yhbmwu41b5">
                {stat.label}
              </p>
            </div>)}
        </dl>
      </div>
    </section>;
}